import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { trigger, transition, style, animate } from '@angular/animations';

// Étendre l'interface Window
interface YouTubeWindow extends Window {
  YT: any;
  onYouTubeIframeAPIReady: () => void;
}

declare var window: YouTubeWindow;

@Component({
  selector: 'app-intro-banner',
  templateUrl: './intro-banner.component.html',
  styleUrls: ['./intro-banner.component.scss'],
  animations: [
    trigger('slideFadeIn', [
      transition(
        ':enter',
        [
          style({ opacity: 0, transform: 'translateY(20px)' }),
          animate(
            '0.25s {{delay}}ms ease-out',
            style({ opacity: 1, transform: 'translateY(0)' })
          ),
        ],
        { params: { delay: '0' } }
      ),
    ]),
  ],
})
export class IntroBannerComponent implements AfterViewInit, OnDestroy {
  @ViewChild('titleOverlay') titleOverlay!: ElementRef;
  @ViewChild('container') container!: ElementRef;
  @ViewChild('videoContainer') videoContainer!: ElementRef;
  private player: any;
  private YT: any;

  script: string =
    'https://unpkg.com/@splinetool/viewer@1.0.34/build/spline-viewer.js';

  partners = this.translate.instant('home_intro_banner.partners');

  constructor(
    private renderer: Renderer2,
    private translate: TranslateService,
    private el: ElementRef
  ) {}

  ngAfterViewInit() {
    this.loadScript();
    this.updateTitle();
  }

  loadScript() {
    const script = this.renderer.createElement('script');
    script.src = this.script;
    script.type = 'module';
    this.renderer.appendChild(document.body, script);
  }

  updateTitle() {
    const titles = this.translate.instant('home_intro_banner.titles');

    let index = 1;
    let first = false;

    const titleElement = this.titleOverlay.nativeElement;

    setInterval(() => {
      this.renderer.addClass(titleElement, 'slide-middle-to-down');
      setTimeout(() => {
        this.renderer.removeClass(titleElement, 'slide-middle-to-down');
        this.renderer.addClass(titleElement, 'slide-up');
        setTimeout(() => {
          titleElement.innerText = titles[index];
          this.renderer.removeClass(titleElement, 'slide-up');
          this.renderer.addClass(titleElement, 'slide-top-to-middle');
          setTimeout(() => {
            this.renderer.removeClass(titleElement, 'slide-top-to-middle');
            index = index < titles.length - 1 ? index + 1 : 0;
            first = !first;
          }, 400);
        }, 200);
      }, 500);
    }, 3000);
  }

  ngOnDestroy() {
    if (this.player) {
      this.player.destroy();
    }
  }

  loadedVideo() {
    const scriptId = 'youtube-api';

    if (document.getElementById(scriptId) === null) {
      const script = this.renderer.createElement('script');
      script.id = scriptId;
      script.src = 'https://www.youtube.com/iframe_api';
      this.renderer.appendChild(document.body, script);
    }

    window.onYouTubeIframeAPIReady = () => this.initPlayer();
  }

  initPlayer() {
    this.YT = window['YT'];
    this.player = new this.YT.Player('videoPresentation', {
      height: '315',
      width: '560',
      videoId: 'MK_0RaJ2SKs',
      title: this.translate.instant('home_intro_banner.video_title'),
      style: 'absolute top-0 h-full w-full',
      events: {
        onReady: (event: any) => this.onPlayerReady(event),
      },
    });

    this.videoContainer.nativeElement.classList.add('video-playing');
  }

  onPlayerReady(event: any) {
    event.target.playVideo();
  }
}
